import { useEffect, useState, useContext, useCallback, useMemo, memo} from 'react'
import { Link, useNavigate, useParams } from "react-router-dom";
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import {Config} from '../inc/Config'

import './css/Task.css'
import { AppContext } from "../Context";
import Fetch, { Loader, dateToText } from "../inc/Fetch";
import Randlet, { Img, SpeackBtn } from "../components/Elements";

import Footer from "./Footer";
import Header from "./Header";
import SendTask from "./popups/SendTask";

import { RiQuestionAnswerLine } from "react-icons/ri";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { MdOutlineErrorOutline, MdDeleteOutline, MdEdit, MdCalendarMonth, MdOutlineQuestionAnswer, MdOutlineSchool, MdOutlineAccessTime, MdLightbulbOutline, MdRadioButtonUnchecked, MdRadioButtonChecked, MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { IoMdRadioButtonOff, IoMdRadioButtonOn, IoIosCheckmarkCircleOutline } from "react-icons/io";
import { IoCheckmark, IoClose } from "react-icons/io5";
import { FaCheck } from "react-icons/fa";
import Missing from './questions/Missing';
import Sorting from './questions/Sorting';
import Options from './questions/Options';
import Checkbox from './questions/Checkbox';
import TextQuestion from './questions/Text';
import MissingNew from './questions/MissingNew';


const ItemType = 'WORD';

const DropSpan = ({ id, expected, onDrop, droppedWord, onRemove }) => {
    const [{ isOver, canDrop }, dropRef] = useDrop(() => ({
        accept: ItemType,
        drop: (item) => onDrop(item.word, expected, id),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }));

    const handleClick = () => {
        if (droppedWord) {
            onRemove(id);
        }
    };

    const isActive = isOver && canDrop;
    // console.log(id);
    
    return (
        // <span class='drop d_${i}' answer='${indexFind}' id='d_${i}'></span>
        <span
            ref={dropRef}
            id={`d_${id}`}
            className={`drop ${isOver ? "hover" : ""} ${droppedWord?.name ? "active" : ""}`}
            
        >{droppedWord?.name ? <strong><dt onClick={handleClick}>x</dt>{droppedWord?.name}</strong> : <b>___</b>}</span>
    );
};

const DraggableWord = ({ word }) => {
    const [{ isDragging }, dragRef] = useDrag(() => ({
        type: ItemType,
        item: { word },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));

    return (
        <label ref={dragRef} className='radio' key={word}>{word}</label>
    );
};



export default function TeacherTaskPrev() {

	const {success, userinfo, languageText, cartData} = useContext(AppContext);
	const [open, setopen] = success;
	const [logedIn, setlogedIn] = userinfo;
	const [text, settext] = languageText;
	const [cart, setcart] = cartData; 


	const [loader, setloader] = useState(true);
	const [loader2, setloader2] = useState(false);
	const [data, setdata] = useState([]);
	const [values, setvalues] = useState([]);

	const [showsendTask, setshowsendTask] = useState(false); 
	const [answers, setanswers] = useState([]); 
	
	const [showAnswers, setshowAnswers] = useState(false); 
	const [showAllAnswers, setshowAllAnswers] = useState(false); 


	const [step, setstep] = useState(0); 

	const [submitted, setsubmitted] = useState(false); 
	const [error, seterror] = useState(false); 
	const [already, setalready] = useState(); 

	const [letters, setletters] = useState({}); 

	let loc = useParams();
	let nav = useNavigate();


	function youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url?.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }

	function saveAns(e) {
		
		setvalues(p => [...p?.filter(r => r?.ID != e?.ID), e])
		
	}
	
	function submit() {
		setloader2(true);
		// console.log(values);
		Fetch("tasks/save", (d) => {
			
            
			if (d?.error) {
				setopen({ error: true, short: d?.error });
			} else {
				setopen({ error: false, short: "تم ارسال المهمة للمعلم بنجاح." });
				
				setTimeout(() => {
					nav('/MyTasks');
				}, 2500);
			}
			

			setloader2(false);
		}, { values:values, task: data?.task });
	}

	useEffect(() => {

		Fetch("tasks/start", (d) => {

			if (d?.error) {
				seterror(d?.error);
			} else {
				
				d.task.time_start = Date.now();
				setdata(d);
				
				if (d?.task?.background) {
					document.body.style.backgroundImage = `url(${Config?.imgUrl}${d?.task?.background})`;
				} else {
					document.body.style.backgroundImage = `url(${Config?.imgUrl}Files/taskBG.jpg)`;
				}
				
				document.body.style.backgroundSize = 'cover';
				document.body.style.backgroundRepeat = 'no-repeat'; 
				document.body.style.backgroundPosition = 'center';
				document.body.style.backgroundAttachment = 'fixed';
				
				if (d?.already?.finished) {
					setalready(d?.already?.answers);
				}
				
			}

			setloader(false);
		}, { _id: loc?.id });


	}, []);
	
	if (loader) {
		return (
			<Loader />
		);
	}

	
	if (error) {
		
		return (
			<div className='answerSuccess er'>
				<div>
					<MdOutlineErrorOutline />
					<h1>خطأ </h1>
					<p>{error}</p>

					<a href='javascript:void(0)' onClick={() => nav(-1)} className='btn'>الرجع الى مهامي</a>
				</div>
				

			</div>
		);
	}

	if (!logedIn?.userinfo?.userlevel) {
		return (
			<div className='answerSuccess er'>
				<div>
					<MdOutlineErrorOutline />
					<h1>ليس لديك صلاحية</h1>
					<p>نأسلف, انت لا تملك اللاحية للدخول الى هذه المهمة.</p>

					<Link to='/' className='btn'>الرجوع الى البيت</Link>
				</div>
				

			</div>
		);
	}
	
	

	if (submitted) {
		return (
			<div className='answerSuccess'>
				<div>
					<IoIosCheckmarkCircleOutline />
					<h1>{text?.alertSuccessTitle}!!</h1>
					<p>{text?.quiz_sent_success}.</p>

					{submitted?.score ?
						<>
						{submitted?.score <= 50 ?
							<score className="error">{submitted?.score}%</score>
						:
							<score >{submitted?.score}%</score>
						}
						<b>{text?.your_score_is}:</b>
						
						</>
					: false}

					<a href='javascript:void(0)' onClick={() => nav(-1)} className='btn'>{text?.return_to_my_tasks}</a>
				</div>
				

			</div>
		);
	}



	let splitCls = logedIn?.userinfo?.classes[0]?.split("-")
	let className = `${global.Classes[splitCls[0]]} (${global.Grades[splitCls[1]]})`


	return (
		<>
			{logedIn?.userinfo?.userlevel == 1 ?

				<div onClick={submit} className='submitBoxBtn'>
					ارسل الاجابات للمعلم
				</div>
			:
				<a onClick={() => setshowAllAnswers(p => !p)} className='showAllAnswersBox'>
					{showAllAnswers ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />} مشاهدة كافة الاجابات
				</a>
			}


			<Header small={true} hideEffect={true}/>

			<div className='body taskBox' >
				

				{loader2 && <Loader />}
				<div className='mainWidth '>

					<div className='cp'>
						<div className='containerBox' >

							

							{data?.task?.story && 
								<div className={`questionsBox show`}>
									<h1>القطعة</h1>

									<div dangerouslySetInnerHTML={{__html:`${data?.task?.story}`}} style={{padding:20}}></div>
								
								</div>
							}
							

							{data?.task?.questions?.map((v, k) => {
								let myAnswers = false;
								if (already) {
									myAnswers = already?.filter(r => r?.ID == v?.ID);
									if (myAnswers?.length) {
										myAnswers = myAnswers[0]?.answer;
									}
								}
								
								
								let pls = 1;
								if (data?.task?.story) {
									pls = 2;
								}

								let yID = youtube_parser(v?.video?.video_url);
								let answerShow = false;
								if (showAnswers == v?.ID) {
									answerShow = true;
								}

								if (showAllAnswers) {
									answerShow = true;
								}
			
								return (
									<div style={{borderRadius:0, marginTop:"40px"}} className={`questionsBox show`} key={k} id={`id-${v?.ID}`}>
										{/* {already?.finished && <>
											{trueAnswer ? <FaCheck className='answerTrueFalse answerTrue' /> : <IoClose className='answerTrueFalse answerFalse' /> }
										</>} */}
										
										{/* <h1 className='teacherTaskTitle' style={{borderRadius:0}}>السؤال رقم ({k + 1}) <a title='Show the right answers' onClick={() => setshowAnswers(p => p == v?.ID ? false : v?.ID)}>{showAnswers == v?.ID ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}</a></h1> */}
										<h1 className='teacherTaskTitle' style={{borderRadius:0}}>السؤال رقم ({k + 1}) </h1>

										<div className='questionsBoxQ'>
											{v?.notes && <p className='noteBox'>{v?.notes}</p>}
											{v?.type == 1 && <h3>{v?.question}</h3>}
											{v?.type == 2 && 
												<div key={k} className='qVideoPlayer'>
													<iframe  src={`https://www.youtube.com/embed/${yID}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
													<h3>{v?.video?.video_title}</h3>
													<p>{v?.video?.video_desc}</p>
												</div>
											}
											{v?.type == 3 && 
												<div key={k} className='qVideoPlayer'>
													<audio controls style={{width:"100%"}}>
														<source src={`${Config?.imgUrl}${v?.file?.file}`} type="audio/mpeg" />
													</audio>
													<h3>{v?.file?.file_title}</h3>
													<p>{v?.file?.file_desc}</p>
												</div>
											}
											{v?.type == 4 && 
												<div key={k} className='qVideoPlayer'>
													<img style={{width:"100%", aspectRatio:16/9, objectFit:"cover", borderRadius:10, border:"1px solid #eee"}} src={`${Config?.imgUrl}${v?.file?.file}`} />
													<h3>{v?.file?.file_title}</h3>
													<p>{v?.file?.file_desc}</p>
												</div>
											}
											{v?.type == 5 && 
												<div key={k} className='qVideoPlayer'>
													<SpeackBtn text={v?.file?.file_word} />
													<h3>{v?.file?.file_title}</h3>
													<p>{v?.file?.file_desc}</p>
												</div>
											}

											{!v?.answersType && 

												<Options 
													v={v}
													student_answer={myAnswers}
													showAllAnswers={showAllAnswers}
													onChange={saveAns}
												/>
								
											}

											{v?.answersType == 2 && 
												<Checkbox 
													student_answer={myAnswers}
													onChange={saveAns}
													v={v}
													showAllAnswers={showAllAnswers}
												/>
												
											}

                                            {v?.answersType == 3 && 
                                                <TextQuestion
                                                    v={v}
                                                    student_answer={myAnswers}
													onChange={saveAns}
                                                    showAllAnswers={showAllAnswers}
                                                />
                                                
                                            }
                                            {v?.answersType == 4 && 
                                                <MissingNew
                                                    v={v}
                                                    student_answer={myAnswers}
                                                    onChange={saveAns}
                                                    showAnswers={showAllAnswers}
                                                />
                                                
                                            }

{/* 
											{v?.answersType == 3 &&  

												<div className='answersBox' >
													<Missing
														student_answer={myAnswers}
														v={v}
														onChange={saveAns}
														showAnswers={showAllAnswers}
													/>
												</div>

											}

											{v?.answersType == 4 &&  
												<div className='answersBox'>
													<div className='sortingBox'>
														<Sorting 
															student_answer={myAnswers}
															v={v}
															onChange={saveAns}
															showAnswers={showAllAnswers}

														/>
													</div>
												</div>

											} */}

											{/* <div className='btnSection' style={{justifyContent:"flex-end"}}>
									
												<a href='javascript:void(0)' onClick={() => setstep(p => p - 1)} className='btn gray'>{text?.back}</a>
												
												{data?.task?.questions?.length == step ?
													<>

													{!already?.finished && <a onClick={() => submit()} className='btn'>{text?.send_quiz_now}</a>}
													</>
												:
													<a href='javascript:void(0)' onClick={() => setstep(p => p + 1)} className='btn'>{text?.next} {text?.question}</a>
												}
											</div> */}

										</div>
									</div>
								);
							})}
							
							

						</div>
					</div>

				</div>
			</div>

		</>
	);
		
	
}
